import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, switchMap, throwError } from 'rxjs';
import { TokenRefreshService } from '@services/token-refresh.service';
import { AuthService } from '@services/auth.service';

export const tokenRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenRefresh = inject(TokenRefreshService);
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastrService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      return tokenRefresh.refreshAccessToken().pipe(
        switchMap(newToken => {
          const retried = req.clone({
            setHeaders: { Authorization: `Bearer ${newToken}` },
          });
          return next(retried);
        }),
        catchError(() => {
          auth.logout();
          toast.error(
            'Votre session a expiré. Veuillez vous reconnecter.',
            'Session expirée'
          );
          void router.navigate(['/login'], { replaceUrl: true });
          return throwError(() => error);
        })
      );
    })
  );
};
